exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-templates-boiler-repairs-js": () => import("./../../../src/templates/boiler-repairs.js" /* webpackChunkName: "component---src-templates-boiler-repairs-js" */),
  "component---src-templates-repairs-js": () => import("./../../../src/templates/repairs.js" /* webpackChunkName: "component---src-templates-repairs-js" */),
  "component---src-templates-repairs-march-25-js": () => import("./../../../src/templates/repairs-march25.js" /* webpackChunkName: "component---src-templates-repairs-march-25-js" */)
}

